module.exports = __webpack_public_path__ + "1ce23e9fa9a85389fa86884a401f6f4f.svg";